import React, { useContext, useRef, useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { useLazyGetTemplatesListQuery } from '../../../../api/simulation/simulation'
import TemplateCard from './TemplateCard'
import { useInfiniteScroller } from '../../useInfiniteScroller'
import { QueryParamsTemplateContext } from './QueryParamsTemplateContext'
import Spacer from 'src/common/components/Spacer'
import { TableHeaderButton } from 'src/common/components/DataGrid'
import companyService from 'src/services/company.service'
import { parseJwt } from 'src/heplers'

const defaultFilters = {
  page: 0,
  size: 16
}

export default function TemplateCardList({ input }) {
  const { value, onChange } = input
  const { params } = useContext(QueryParamsTemplateContext)
  const isUserInteraction = useRef(false)
  const [templateList, setTemplateList] = useState(value || [])
  const [languages, setLanguages] = useState([])

  const [sortBy, setSortBy] = useState({ filed: '', direction: '' })
  const [filters, setFilters] = useState(defaultFilters)

  const onSort = sort => {
    setSortBy({ field: sort.field, direction: sort.direction })
  }
  const handleFilter = param => {
    setFilters({ ...filters, ...param })
  }

  function handleTemplateClick(templateId) {
    isUserInteraction.current = true
    setTemplateList(prevState => {
      if (prevState.includes(templateId)) {
        return prevState.filter(id => id !== templateId)
      }
      return [...prevState, templateId]
    })
  }

  useEffect(() => {
    const userLocal = JSON.parse(localStorage.getItem('user'))
    const user = parseJwt(userLocal?.accessToken)

    companyService.getSimulationsLanguages().then(resp => {
      setLanguages(resp.data)
      const allowedLangs = resp.data
      companyService.getCompany(user.companyId).then(companyData => {
        const companyLanguage = allowedLangs.includes(companyData.data.language) ? companyData.data.language : 'English'
        setFilters({ ...filters, language: companyLanguage })
      })
    })
  }, [])

  useEffect(() => {
    setTemplateList(value || [])
  }, [value])

  useEffect(() => {
    if (isUserInteraction.current) {
      onChange(templateList)
      isUserInteraction.current = false
    }
  }, [templateList, onChange])

  const { InfiniteItems } = useInfiniteScroller({
    apiHook: useLazyGetTemplatesListQuery,
    options: {
      page: 0,
      size: 16,
      active: true,
      includeBody: true,
      ...(filters?.language && { language: filters?.language }),
      ...(sortBy.direction && { sort: 'language,' + sortBy.direction })
    },
    params,
    renderItem: template => (
      <TemplateCard
        key={template.id}
        card={template}
        onChange={handleTemplateClick}
        templateList={templateList}
        isChosenDefault={templateList.includes(template?.id)}
      />
    )
  })

  const col = {
    field: 'language',
    headerName: 'Language',
    filterOptions: languages,
    isLast: true
  }

  return (
    <>
      <div className='row row-center'>
        <Typography sx={{ fontFamily: 'Plus Jakarta Sans', fontSize: 18, fontWeight: 600, color: '#76767F' }}>
          System templates
        </Typography>
        <Spacer />
        <TableHeaderButton
          style={{ zIndex: 200, marginRight: 20 }}
          sortBy={sortBy}
          onSort={onSort}
          onFilter={handleFilter}
          col={col}
          filters={{ language: filters.language }}
        />
      </div>
      {InfiniteItems()}
    </>
  )
}
